// Compiled at 2026-10-07T06:21:14.844Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty, jsonArrayProperty, AnyType } from "@sumbricht/json-class-serializer";
import { BoInfoSymbol } from "@lg/shared";
import { computed, isSignal } from "../../signals.js";
import { Signals, HasSignalProperties } from "@lg/shared";
import { equal } from "@lg/shared";
import * as z from "zod";
import { immerable } from "immer";
import { untracked } from "@angular/core";

const $schemas = new Map<string, z.ZodObject<any>>();
@jsonClass('Toolbox.GoalSettingAttachment')
class Toolbox__GoalSettingAttachment {
    @jsonProperty(() => Toolbox__GoalSettingAttachment.Id)
    id: Toolbox__GoalSettingAttachment.Id;
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "number" as const,
        editablePropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "fileName", "owner", "goalSetting", "goalSettingId", "data", "dataId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        allPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "fileName", "owner", "goalSetting", "goalSettingId", "data", "dataId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        propertyNamesOfInterest: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "fileName", "owner", "goalSetting", "goalSettingId", "data", "dataId", "createdOn", "updatedOn", "deletedOn", "versionNumber"] as const)),
        propertyTypes: LowgileDataUtil.unwrapReadonly(Object.freeze({ "fileName": "string", "owner": "System.UserIdAndName", "goalSetting": "Toolbox.GoalSetting", "goalSettingId": "Toolbox.GoalSetting.Id", "data": "System.BinaryData", "dataId": "System.BinaryData.Id", "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number", "id": "number" } as const)),
        staticEntityProperties: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        searchInProperties: LowgileDataUtil.unwrapReadonly(Object.freeze(["id"] as const)),
        subsetNames: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        manyToOneRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({ goalSetting: () => Toolbox.GoalSetting } as const)),
        oneToManyRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        oneToOneOwningRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({ data: () => System.BinaryData } as const)),
        oneToOneSecondaryRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        embeddedEntities: LowgileDataUtil.unwrapReadonly(Object.freeze({ owner: () => System.UserIdAndName } as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = Number;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    private readonly θfileName = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θowner = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θgoalSetting = Signals.proxySignalDeferred<Toolbox.GoalSetting>(() => (undefined) as any);
    private readonly θgoalSettingId = Signals.proxySignalDeferred<Toolbox.GoalSetting.Id>(() => (undefined) as any);
    private readonly θdata = Signals.proxySignalDeferred<System.BinaryData>(() => (undefined) as any);
    private readonly θdataId = Signals.proxySignalDeferred<System.BinaryData.Id>(() => (undefined) as any);
    private readonly θcreatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θupdatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θdeletedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θversionNumber = Signals.proxySignalDeferred<number>(() => (undefined) as any);

    static get __type(): 'Toolbox.GoalSettingAttachment' {
        return 'Toolbox.GoalSettingAttachment'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'Toolbox.GoalSettingAttachment' {
        return 'Toolbox.GoalSettingAttachment'
    }

    static get __baseType(): 'Toolbox.GoalSettingAttachment' {
        return 'Toolbox.GoalSettingAttachment'
    }

    set __baseType(_) {
    }

    get __baseType(): 'Toolbox.GoalSettingAttachment' {
        return 'Toolbox.GoalSettingAttachment'
    }

    get [BoInfoSymbol]() {
        return Toolbox__GoalSettingAttachment[BoInfoSymbol]
    }

    get fileName(): string {
        return this.θfileName?.()
    }

    set fileName(fileName) {
        this.θfileName.set(LowgileDataUtil.coerceDataType(fileName, 'string', false, true))
    }

    get owner(): System.UserIdAndName {
        return this.θowner?.()
    }

    set owner(owner) {
        this.θowner.set(LowgileDataUtil.coerceDataType(owner, 'System.UserIdAndName', false, true))
    }

    get goalSetting(): Toolbox.GoalSetting {
        return this.θgoalSetting?.()
    }

    set goalSetting(goalSetting) {
        this.θgoalSetting.set(LowgileDataUtil.coerceDataType(goalSetting, Toolbox.GoalSetting, false, true))
        if (goalSetting) {
            this.θgoalSettingId.set(goalSetting.id)
        } else if (goalSetting === null && goalSetting) {
            this.θgoalSettingId.set(null)
        }
    }

    get goalSettingId(): Toolbox.GoalSetting.Id {
        return this.θgoalSettingId?.()
    }

    set goalSettingId(goalSettingId) {
        if (goalSettingId === null) this.θgoalSetting.set(null)
        if (this.goalSetting?.id && goalSettingId != this.goalSetting.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θgoalSettingId.set(LowgileDataUtil.coerceDataType(goalSettingId, 'Toolbox.GoalSetting.Id', false, true))
    }

    get data(): System.BinaryData {
        return this.θdata?.()
    }

    set data(data) {
        this.θdata.set(LowgileDataUtil.coerceDataType(data, System.BinaryData, false, true))
        if (data) {
            this.θdataId.set(data.id)
        } else if (data === null && data) {
            this.θdataId.set(null)
        }
    }

    get dataId(): System.BinaryData.Id {
        return this.θdataId?.()
    }

    set dataId(dataId) {
        if (dataId === null) this.θdata.set(null)
        if (this.data?.id && dataId != this.data.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θdataId.set(LowgileDataUtil.coerceDataType(dataId, 'System.BinaryData.Id', false, true))
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(LowgileDataUtil.coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(LowgileDataUtil.coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(LowgileDataUtil.coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(LowgileDataUtil.coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(LowgileDataUtil.coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(LowgileDataUtil.coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(LowgileDataUtil.coerceDataType(versionNumber, 'number', false, true))
    }

    constructor(init?: Partial<Toolbox__GoalSettingAttachment>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                ...init
            }

        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        untracked(() => LowgileDataUtil.assignCommonProperties(this, init))
        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new Toolbox__GoalSettingAttachment()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<Toolbox__GoalSettingAttachment>, restrictToClass?: Class<Partial<Toolbox__GoalSettingAttachment>>) {
        LowgileDataUtil.assignCommonProperties(this, source, { restrictToClass })
    }

    static $getSchema(): any {

        const key = ""
        if ($schemas.has(key)) return $schemas.get(key)!
        const schema = z.object({
            fileName: z.string(),
            get owner() { return System.UserIdAndName.$getSchema() },
            get goalSetting() { return Toolbox.GoalSetting.$getSchema() },
            get goalSettingId() { return z.number() },
            get data() { return System.BinaryData.$getSchema() },
            get dataId() { return z.string() },
            createdOn: z.coerce.date(),
            get createdBy() { return System.UserIdAndName.$getSchema() },
            updatedOn: z.coerce.date(),
            get updatedBy() { return System.UserIdAndName.$getSchema() },
            deletedOn: z.coerce.date(),
            get deletedBy() { return System.UserIdAndName.$getSchema() },
            versionNumber: z.number(),
        }
        )
        $schemas.set(key, schema)
        return schema

    }

    $getSchema(): any {
        return Toolbox__GoalSettingAttachment.$getSchema()
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []
        names.push('id')
        names.push('fileName', 'owner', 'goalSetting', 'goalSettingId', 'data', 'dataId', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    static async download(attachmentId: number, binaryDataId: string): Promise<System.BinaryData> {
        const args = [...arguments]
        const result = await ExecutionService.executeMethodAndReturnData<System.BinaryData>('Entity', 'Toolbox', 'GoalSettingAttachment', undefined, 'download', args)
        return result
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is Toolbox__GoalSettingAttachment {
        return equal(this, other)
    }
}

namespace Toolbox__GoalSettingAttachment { }

export import GoalSettingAttachment = Toolbox__GoalSettingAttachment
setTimeout(() => {
    jsonProperty(() => String)(Toolbox__GoalSettingAttachment.prototype, 'fileName')
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSettingAttachment.prototype, 'owner')
    jsonProperty(() => Toolbox.GoalSetting)(Toolbox__GoalSettingAttachment.prototype, 'goalSetting')
    jsonProperty(() => Toolbox.GoalSetting.Id)(Toolbox__GoalSettingAttachment.prototype, 'goalSettingId')
    jsonProperty(() => System.BinaryData)(Toolbox__GoalSettingAttachment.prototype, 'data')
    jsonProperty(() => System.BinaryData.Id)(Toolbox__GoalSettingAttachment.prototype, 'dataId')
    jsonProperty(() => Date)(Toolbox__GoalSettingAttachment.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSettingAttachment.prototype, 'createdBy')
    jsonProperty(() => Date)(Toolbox__GoalSettingAttachment.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSettingAttachment.prototype, 'updatedBy')
    jsonProperty(() => Date)(Toolbox__GoalSettingAttachment.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(Toolbox__GoalSettingAttachment.prototype, 'deletedBy')
    jsonProperty(() => Number)(Toolbox__GoalSettingAttachment.prototype, 'versionNumber')
})

export const GoalSettingAttachmentθId = Number;

export type GoalSettingAttachmentθId = number;

namespace Toolbox__GoalSettingAttachment {
    export type Id = NominalType<number, 'Toolbox.GoalSettingAttachment'>

}
